export default __webpack_public_path__ + "static/s7-2c1dbe0390a3a1b91721acea7e9fe971.jpg";